import React from "react";

const ShortGradeCell = (props) => {
    const { cell } = props
    let value = cell.getValue()
    const words = value?.split(" ");

    if (words?.length) {
        const firstWord = words?.[0]
        const secondWord = words?.[1]

        if (value.includes("גן")) {
            if (words.length == 3) {
                const thirdWord = words[2]
                value = `${firstWord} ${thirdWord}`
            }
            else
                value = `${firstWord} ${secondWord[0]}.`
        }
        else if (secondWord)
            value = secondWord
    }

    return value
}

export default ShortGradeCell